<template>
  <div class="tw-flex tw-flex-col tw-mb-4 tw-w-full">
    <label class="tw-mb-3.5 tw-text-[#4F4F4F]" :for="forId">{{ label }}</label>
    <ValidationProvider
      v-slot="{ errors }"
      :rules="validationRules"
      :name="name || label"
    >
      <slot :errors="errors"></slot>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    forId: {
      type: String,
      required: true,
    },
    validationRules: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style></style>
